export const getShippingPageView = state => {
  return state.shippingPageView
}

export const getShippingRegionList = state => {
  return state.regionList
}

export const getShippingRegion = state => {
  return state.region
}

export const getCountry = state => {
  return state.country
}

export const getShippingItemList = state => {
  return state.shippingItemList
}

export const getShippingType = state => {
  return state.shippingType
}

export const getShippingConfig = state => {
  return state.shippingConfig
}

export const getShippingLimit = state => {
  return state.limit
}

export const getShippingLinkManual = state => {
  return state.link_manual
}

export const getShippingProvince = state => {
  return state.shipping_province
}

export const getTabSelected = state => {
  return state.shippingTabSelected
}

export const getDeleteShippingItemData = state => {
  return state.deleteShippingItemData
}



// WEBPACK FOOTER //
// ./src/store/modules/shipping/getters.js